module.exports = __webpack_public_path__ + "media/sintel-short.4b83956d.webm";